import { Card, Col, Form, Input, Row, Typography } from "antd";
import React, { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
const { Title } = Typography;

const Facility = ({ getChildData }) => {
  const { t, i18n } = useTranslation();
  const callparent = (e, name) => {
    getChildData(e, name);
  };

  const validatePhone = useCallback((_, value) => {
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("patientDetails:please_enter_a_valid_phone_number")));
  }, [t]);

  const validationRules = useMemo(() => ({
    facilityName: [
      { required: true, max: 100, message: t("patientDetails:please_enter_facility_name_doctor_name") }
    ],
    facilityEmail: [
      { max: 100, message: t("patientDetails:please_enter_facility_email") },
      { type: "email", message: t("patientDetails:please_enter_valid_email") }
    ],
    facilityPhone: [
      { max: 20, message: t("patientDetails:please_enter_phone_number") },
      { validator: validatePhone }
    ],
    address1: [
      { required: true, max: 150, message: t("patientDetails:please_enter_address") }
    ],
    city: [
      { required: true, max: 50, message: t("patientDetails:please_enter_city_name") }
    ],
    state: [
      { required: true, message: t("patientDetails:please_enter_state_name") }
    ],
    zipCode: [
      { max: 8, required: true, message: t("patientDetails:please_enter_zip_code") },
      { pattern: /^[0-9]+$/, message: t("patientDetails:zip_code_must_be_numeric") },
      { min: 5, message: t("patientDetails:zip_code_must_be_at_least_5_digits_long") }
    ]
  }), [t, validatePhone]);
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("patientDetails:facility_information")}
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-1 lg:px-6">
        <Col span={24}>
          <label className="font-medium text-[0.813rem] mb-4 flex">{t("patientDetails:at_which_facility_did_the_patient_receive_care")}</label>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="ffacilityname"
            label={t("patientDetails:facility_name_doctor_name")}
            onChange={(e) => callparent(e.target.value, "ffacilityname")}
            rules={validationRules.facilityName}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}></Col>
        <Col xs={24} md={12}>
          <Form.Item
            label={t("patientDetails:facility_email")}
            name="Facility_Email"
            onChange={(e) => callparent(e.target.value, "Facility_Email")}
            rules={validationRules.facilityEmail}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="fphone"
            className="font-medium"
            label={t("patientDetails:facility_phone_number")}
            onChange={(e) => callparent(e.target.value, "FacilityPhoneNumber")}
            rules={validationRules.facilityPhone}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="faddress1"
            label={t("patientDetails:address_line_1")}
            onChange={(e) => callparent(e.target.value, "FacilityAddressLine1")}
            rules={validationRules.address1}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="faddress2"
            className="font-medium"
            label={t("patientDetails:address_line_2")}
            onChange={(e) => callparent(e.target.value, "FacilityAddressLine2")}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="fcity"
            label={t("patientDetails:city")}
            onChange={(e) => callparent(e.target.value, "FacilityCity")}
            rules={validationRules.city}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="fstate"
            label={t("patientDetails:state")}
            onChange={(e) => callparent(e.target.value, "FacilityState")}
            rules={validationRules.state}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="fzipcode"
            label={t("patientDetails:zip_code")}
            onChange={(e) => callparent(e.target.value, "FacilityZipCode")}
            rules={validationRules.zipCode}
          >
            <Input maxLength={8} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};
export default Facility;
